import React, { useEffect, useState } from "react";

import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";
import "../style/CookieConsent.scss";
import Cookies from "js-cookie";

const Cookieconsent = () => {
  const [language, setLanguage] = useState<any>(en);
  const [cookie, setCookie] = useState<string>("");

  useEffect(() => {
    const browserLanguage: string = navigator.language.split("-")[0];
    if (sessionStorage.getItem("lang") === null) {
      setLanguage(browserLanguage === "de" ? de : en);
    } else {
      const sessionLang = sessionStorage.getItem("lang");
      setLanguage(sessionLang === "de" ? de : en);
    }
  }, []);

  const onClickAcceptDeny = (answer: Boolean) => {
    const d = new Date();
    const exdays = 30;

    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie =
      "CookieAccepted" +
      "=" +
      answer +
      ";" +
      expires +
      ";path=/" +
      ";" +
      "secure" +
      ";" +
      "SameSite=Lax";
    if (answer === true) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "hs-script-loader";
      script.src = "//js.hs-scripts.com/5080665.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
    setCookie(Cookies.get("CookieAccepted") ?? "");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (document.getElementById("hs-eu-policy-wording") !== null) {
        document.getElementById("hs-eu-policy-wording")!.textContent =
          language.cookieTracking.policyWording;

        document.getElementById("hs-eu-cookie-disclaimer")!.textContent =
          language.cookieTracking.cookieDisclaimer;

        document.getElementById("hs-eu-confirmation-button")!.textContent =
          language.cookieTracking.btnAccept;

        document.getElementById("hs-eu-decline-button")!.textContent =
          language.cookieTracking.btnDecline;
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [cookie]);

  return (
    <>
      {Cookies.get("CookieAccepted") === undefined ? (
        <div className="cookieConsent">
          <div className="cookieConsent-text-container">
            <span>{language.cookieFirst.bodyText}</span>
          </div>
          <div className="cookieConsent-btns">
            <button onClick={() => onClickAcceptDeny(true)}>
              {language.cookieFirst.btnAccept}
            </button>
            <button onClick={() => onClickAcceptDeny(false)}>
              {language.cookieFirst.btnDeny}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Cookieconsent;
